export default __webpack_public_path__ + "static/media/harry-r-marked.89906600.png";